<template>
  <div v-loading="loading" class="cont">
    <div class="goods_where">
      <el-tabs v-model="tabsData.current" @tab-click="handleTab">
        <el-tab-pane v-for="(item, index) in tabsData.list" :key="index" :label="item"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="goods_list" v-if="goodsList.length > 0">
      <ul>
        <li class="item" v-for="item in goodsList" :key="item.id">
          <goods-card :vem="true" :item="item" @update="$parent.getCartList()"></goods-card>
        </li>
      </ul>
      <div class="clear"></div>
      <div class="home_fy_block" style="margin: 20px auto;">
        <el-pagination
          @current-change="changePage"
          background
          layout="prev, pager, next,jumper,total"
          :total="total"
          :page-size="goodsParams.pageSize"
          :current-page="goodsParams.pageNum"
        ></el-pagination>
      </div>
    </div>
    <el-empty v-else :description="lang.no_data"></el-empty>
  </div>
</template>

<script>
import { getvendproducttype, getvendproductpage } from '@/api/vendingmachine'
import GoodsCard from '@/components/MachineGoods/index'

export default {
  components: {
    GoodsCard
  },
  data() {
    return {
      tabsData: {
        list: [],
        current: ''
      },
      goodsList: [],
      goodsParams: {
        keyword: '',
        typename: '',
        pageNum: 1,
        pageSize: 12
      },
      total: 0,
      loading: false
    }
  },
  computed: {
    lang() {
      return this.$t('goods')
    },
    vemId() {
      return this.$route.query.vemId
    }
  },
  mounted() {
    this.getClassify()
  },
  methods: {
    // 获取自助机分类
    getClassify() {
      this.loading = true
      getvendproducttype({
        vemId: this.vemId
      }).then(({ data }) => {
        this.tabsData.list = data
        this.goodsParams.typename = data[0]
        this.getList()
      })
    },
    // 获取自助机商品
    getList() {
      getvendproductpage({
        ...this.goodsParams,
        vemId: this.vemId
      }).then(({ data }) => {
        this.loading = false
        this.total = data.count
        this.goodsList = data.data.map((item) => {
          return {
            ...item,
            title: item.mercName
          }
        })
      })
    },
    // 处理分类选择
    handleTab(val) {
      this.goodsParams.typename = this.tabsData.list[parseFloat(val.index)]
      this.goodsParams.pageNum = 1
      this.getList()
    },
    // 分页
    changePage(val) {
      this.goodsParams.pageNum = val
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.goods_where {
  background: #fff;
  margin: 0 auto 20px;
  /deep/ .el-tabs__header {
    margin: 0;
  }
  /deep/ .el-tabs__nav-wrap::after {
    display: none;
  }
  /deep/ .el-tabs__item.is-active {
    color: #4f4f4f;
  }
  /deep/ .el-tabs__active-bar {
    background-color: #ec9221;
  }
  /deep/ .el-tabs__item:hover {
    color: #ec9221;
  }
  /deep/ .el-tabs__item {
    text-align: center;
    min-width: 109px;
    height: 46px;
    line-height: 46px;
    color: #4f4f4f;
    padding: 0;
    font-size: 12px;
  }
}

.goods_list {
  padding-bottom: 80px;
  width: 110%;
  /deep/ .item {
    float: left;
    box-sizing: border-box;
    margin-right: 16px;
    margin-bottom: 16px;
    width: 283px;
    height: 110px;
    .product,
    .product_act_in {
      width: 283px;
    }
  }
}
</style>